import React, { CSSProperties, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface IEditableFeaturedColorProps {
	color: [string, [string, number] | undefined];
	dragKey: string
	onShowColorPicker: (e: DOMRect) => void;
	isOpen: boolean;
	isDisabled: boolean;
}

export default function EditableFeaturedColor({
	color, dragKey, onShowColorPicker, isOpen, isDisabled
}: IEditableFeaturedColorProps) {

	const {
		attributes, listeners, setNodeRef, transform, node, transition
	} = useSortable({
		id: dragKey,
		transition: { duration: 200, easing: 'cubic-bezier(0.25, 1, 0.5, 1)' },
	});

	const handleClick = () => {
		if (node.current && !isOpen) {
			onShowColorPicker(node.current.getBoundingClientRect());
		}
	}

	return (
		<div 
			className={classNames('edit-theme-swatch-wrapper', {inactive: isDisabled})}
			key={dragKey}
			ref={setNodeRef}
			{...attributes}
			{...listeners}
			style={{
				transform: CSS.Transform.toString(transform),
				transition:  transition || ''
			}}
		>
			<div className="editable-featured-color-item">
				<div className="editable-featured-color-item-title bl-font-s2">
					<span>{color[0]}</span>
				</div>
				<div className="editable-featured-color-item-preview-container">
					<button
						className={classNames(
							"clear no-style editable-featured-color-item-preview",
							{
								selected: isOpen,
								showBackgroundImage: !color?.[1]?.[0],
							}
						)}
						style={{'--editable-featured-color-item-bg-color': color?.[1]?.[0]} as CSSProperties}
						onClick={handleClick}
					/>
				</div>
				<div
					className={classNames(
						"editable-featured-color-item-hex",
						"flex-center",
						{'lemonade-text': !color?.[1]?.[0]}
					)}
					style={{ cursor: color?.[1]?.[0] ? 'default' : 'pointer' }}
					onClick={handleClick}
				>
					<span className="editable-featured-color-item-hex-value bl-font-s3 flex-center">
						<div className={classNames('bl-font-s3 edit-theme-swatch-footer')}>
							<span className='hashtag'>#</span>
							<span className='hexfield'>
								{(color[1]?.[0] ?? '#000000').split('#')[1]}
							</span>
						</div>
					</span>
				</div>
			</div>
		</div>
	);
};

